const BrandLogos = () => {



    const brands = [
        {
            id: 1,
            image: "https://portotheme.com/html/porto_ecommerce/assets/images/brands/small/brand2.png",
            name: "Black Grey Headset",
        },
        {
            id: 2,
            image: "https://portotheme.com/html/porto_ecommerce/assets/images/brands/small/brand3.png",
            name: "Battery Charger",
        },
        {
            id: 3,
            image: "https://portotheme.com/html/porto_ecommerce/assets/images/brands/small/brand4.png",
            name: "Abc Charger",
        },
        {
            id: 4,
            image: "https://portotheme.com/html/porto_ecommerce/assets/images/brands/small/brand3.png",
            name: "Battery Charger",
        },
    ];

    return (
        <div className="my-8 py-8 border-y border-gray-200">
            <div className="flex items-center justify-around">
                {brands.map((brand, index) => (
                    <div key={index} className="text-xl font-bold text-gray-400 hover:text-gray-600 cursor-pointer transition">
                        {/* {brand.name} */}
                        <img
                            src={brand.image}
                            alt={brand.name}
                            className="w-50 h-20 object-cover rounded"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BrandLogos;
